module.exports = __webpack_public_path__ + "img/S2F5.9315f042.jpg";